(() => {
  const dialog=document.getElementById('SALeadGate');
  if(!dialog || dialog.dataset.ready)return;
  dialog.dataset.ready='true';
  const form=dialog.querySelector('[data-lead-contact]'),error=dialog.querySelector('[data-lead-error]'),button=dialog.querySelector('[data-lead-continue]');
  const buttonContent=button.innerHTML;
  const allowed=new WeakSet();let intent=null,busy=false,noncePromise;
  const money=value=>new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(value/100);
  function endpoint(path){
    const url=new URL(dialog.dataset.endpoint);
    if(url.protocol!=='https:' && !(location.hostname==='127.0.0.1' && url.origin===location.origin))throw new Error('NOT_CONFIGURED');
    return new URL('/api/'+path,url.origin).href;
  }
  const showError=text=>{error.textContent=text;error.hidden=false;};
  function close(){if(busy)return;dialog.close();form.reset();error.hidden=true;intent=null;}
  dialog.querySelectorAll('[data-lead-close]').forEach(b=>b.addEventListener('click',close));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  function selection(purchase){
    if(!(purchase instanceof HTMLFormElement)||!purchase.action.includes('/cart/add'))return null;
    const data=new FormData(purchase),wrapper=purchase.closest('[data-sa-lead-variants]');
    if(!wrapper)return null;
    let variants;try{variants=JSON.parse(wrapper.dataset.saLeadVariants);}catch{return null;}
    const variant=variants.find(v=>String(v.id)===String(data.get('id')));
    return variant&&Number(variant.price)>500000000?{data,wrapper,variant}:null;
  }
  // Stop native quick-add animations until the contact step has completed.
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('button[type="submit"],button[name="add"]');
    if(!trigger?.form || allowed.has(trigger.form)||!selection(trigger.form))return;
    event.preventDefault();event.stopImmediatePropagation();trigger.form.requestSubmit(trigger);
  },true);
  document.addEventListener('submit',event=>{
    const purchase=event.target;
    if(!(purchase instanceof HTMLFormElement))return;
    if(allowed.has(purchase)){allowed.delete(purchase);return;}
    const selected=selection(purchase);if(!selected)return;
    const {data,wrapper,variant}=selected;
    event.preventDefault();event.stopImmediatePropagation();
    if(!purchase.reportValidity() || !variant.available || busy || dialog.open)return;
    const quantity=Number(data.get('quantity')||1);
    if(!Number.isInteger(quantity)||quantity<1)return;
    intent={purchase,submitter:event.submitter,variant,quantity,id:crypto.randomUUID()};
    dialog.querySelector('[data-lead-product-title]').textContent=wrapper.dataset.saLeadTitle;
    dialog.querySelector('[data-lead-product-price]').textContent=money(variant.price)+' · IVA incluido'+(quantity>1?' · '+quantity+' unidades':'');
    error.hidden=true;dialog.showModal();
    noncePromise=(async()=>{const r=await fetch(endpoint('nonce'),{mode:'cors',cache:'no-store',referrerPolicy:'no-referrer'});if(!r.ok)throw new Error('UNAVAILABLE');return(await r.json()).nonce;})();
    noncePromise.catch(()=>{});
  },true);
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(busy||!intent||!form.reportValidity())return;
    busy=true;button.disabled=true;button.textContent='Guardando tus datos…';error.hidden=true;
    try {
      const data=new FormData(form);
      const payload={name:data.get('name'),phone:data.get('phone'),email:data.get('email'),consent:data.get('consent')==='on',companyWebsite:data.get('companyWebsite'),variantId:String(intent.variant.id),quantity:intent.quantity,requestId:intent.id,policyVersion:'sa-purchase-followup-2026-10-20-v1',nonce:await noncePromise};
      const r=await fetch(endpoint('capture'),{method:'POST',mode:'cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),referrerPolicy:'no-referrer'});
      const result=await r.json();
      if(!r.ok || result.stored!==true || !/^[a-f0-9-]{36}\.[A-Za-z0-9_-]{43}$/.test(result.reference||''))throw new Error(result.code||'SAVE_FAILED');
      const root=window.Shopify?.routes?.root||'/';
      const cartResponse=await fetch(root+'cart.js',{cache:'no-store'});
      if(!cartResponse.ok)throw new Error('CART_FAILED');const cart=await cartResponse.json();
      let refs;try{refs=JSON.parse(cart.attributes?.sa_lead_refs||'[]');}catch{refs=[];}
      if(!Array.isArray(refs))refs=[];
      refs=[...new Set([...refs.filter(x=>typeof x==='string'&&x.length<160),result.reference])];
      if(refs.length>100)throw new Error('CART_FAILED');
      const update=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{sa_lead_refs:JSON.stringify(refs)}})});
      if(!update.ok)throw new Error('CART_FAILED');
      const saved=await update.json();if(saved.attributes?.sa_lead_refs!==JSON.stringify(refs))throw new Error('CART_FAILED');
      const action=intent;allowed.add(action.purchase);busy=false;close();
      action.purchase.requestSubmit(action.submitter || undefined);
    }catch(e){
      showError(e.message==='INVALID_CONTACT'?'Revisa tu nombre, correo y teléfono. Incluye el indicativo si tu número no es de Colombia.':e.message==='PRODUCT_UNAVAILABLE'?'Este equipo ya no tiene la cantidad disponible. Cierra este paso y revisa tu selección.':'No pudimos completar este paso. Tus productos siguen igual. Intenta de nuevo en un momento.');
    }finally{busy=false;button.disabled=false;button.innerHTML=buttonContent;}
  });
})();
